export const FETCH_GAMES = 'FETCH_GAMES';
export const FETCH_GAME = 'FETCH_GAME';
export const FETCH_ABOUT = 'FETCH_ABOUT';
export const FETCH_ABOUT_PAGE = 'FETCH_ABOUT_PAGE';
export const FETCH_NEWS_SECTION = 'FETCH_NEWS_SECTION';
export const FETCH_CONTACT_SECTION = 'FETCH_CONTACT_SECTION';
export const FETCH_FOOTER_SECTION = 'FETCH_FOOTER_SECTION';
export const FETCH_NEWS = 'FETCH_NEWS';
export const PRIVACY_POLICY_SECTION = 'PRIVACY_POLICY_SECTION';